module.exports = __webpack_public_path__ + "static/img/brandYoulai.8848410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/brandYoulai.png
// module id = PEea
// module chunks = 0